<ng-container [formGroup]="formGroup">
  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Dependents</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="add()">
        Add a Dependent
      </lds-button>
    </div>
  </div>

  <div formArrayName="dependents">
    <ng-container *ngIf="form.controls.length > 0; else tplNoItems">
      <ng-container *ngFor="let itemForm of form.controls; let i = index">
        <app-inline-item
          *ngIf="!deleted[i]"
          [form]="itemForm"
          [formGroupName]="i"
          [isExpandable]="true"
          [initiallyExpanded]="expandedIndex === i"
          (delete)="remove(i)">
          <inline-summary>
            <div class="row">
              <div class="col-3">
                {{ itemForm.controls.name.value | summary }}
              </div>
              <div class="col-3">
                {{ itemForm.controls.birthDate.value | toDate | age | summary }}
              </div>
              <div class="col">
                {{
                  itemForm.controls.financiallyDependent.value
                    ? 'Financial Dependent'
                    : ''
                }}
              </div>
            </div>
          </inline-summary>
          <inline-content>
            <div class="row">
              <div class="col-12 col-lg-6">
                <lds-text-input
                  formControlName="name"
                  label="Name"
                  placeholder="dependents name"
                  [maxlength]="50"
                  [isRequired]="schema.name | standardRequirement"
                  [validations]="{ required: 'Name is required' }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="birthDate"
                  label="Date of birth"
                  [isRequired]="schema.birthDate | standardRequirement"
                  [validations]="{
                    required: 'Date of birth is required',
                    date: 'Must be a valid date',
                    dateBefore: 'Must be a date in the past',
                    ageMax: 'Must be under ' + maxDependentAge + ' years'
                  }">
                </lds-date-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-form-field>
                  <lds-label
                    context="financiallyDependent_{{ i }}"
                    [showIndicator]="schema.birthDate | standardRequirement">
                    Financial dependent
                  </lds-label>
                  <lds-toggle
                    formControlName="financiallyDependent"
                    identifier="financiallyDependent_{{ i }}"
                    name="financiallyDependent_{{ i }}">
                  </lds-toggle>
                </lds-form-field>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <app-contact-search
                  formControlName="otherGuardian"
                  label="Other guardian"
                  [isRequired]="schema.otherGuardian | standardRequirement">
                </app-contact-search>
              </div>
            </div>
          </inline-content>
        </app-inline-item>
      </ng-container>
    </ng-container>
    <ng-template #tplNoItems>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      required: 'At least one dependent is required',
      minlength: 'At least one dependent is required'
    }">
  </lds-form-feedback>
</ng-container>
